// Library media paths are RAW /music-relative paths, not pre-encoded URLs.
// Encode segments exactly once so %, #, ?, spaces and Unicode stay filenames.
export function publicMediaUrl(rawPath: string | undefined, apiBase = '/api'): string {
  if (!rawPath?.startsWith('/music/')) return '';
  const parts = rawPath.slice('/music/'.length).split('/');
  if (parts.some(part => !part || part === '.' || part === '..' || /[\\\x00-\x1f\x7f]/.test(part))) return '';
  const origin = apiBase.replace(/\/api\/?$/, '');
  return `${origin}/music/${parts.map(encodeURIComponent).join('/')}`;
}

export function downloadPublicMedia(rawPath: string | undefined): void {
  const url = publicMediaUrl(rawPath, import.meta.env.VITE_API_URL || '/api');
  if (!url) return;
  const link = document.createElement('a');
  link.href = url;
  // Use the backend's actual filename/extension; never label WAV bytes as MP3.
  link.download = '';
  document.body.appendChild(link);
  link.click();
  link.remove();
}
